var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"employee-profile-photo"},[(_vm.profileImgUrl)?_c('div',{staticClass:"profile-img",style:(_vm.profileImageStyle)}):_c('div',{staticClass:"no-profile-img"},[_c('div',{staticClass:"icon-img"},[_c('vue-fontawesome',{attrs:{"icon":['fas', 'user']}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }